import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import { useState } from "react";
import React, { Component }  from 'react';
import SignatureCanvas from "react-signature-canvas";
import services
 from "../../services";
export interface props {
  open: boolean;
  onClose: (value: string) => void;
  handleProgress: (value: string) => void;
}


export default function AssinaturaManuscritoDialog(props: props) {
  //modal control
  const { onClose, open } = props;
  const { handleProgress} = props;
  const handleClose = () => {
    onClose("");
    setDisabled(true);
  };

  //sign control
  const [sign, setSign] = useState<SignatureCanvas | null>(null);
  const [isSign, setIsSign] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);

  const clearHandler = () => {
    if (sign) {
      sign.clear();

      setIsSign(false);
    }
  };
  
  const capturarHandler = () => {
    //set base64 signature
    if (sign) {
      onClose(sign.getTrimmedCanvas().toDataURL("image/png"));
      console.log(sign.getTrimmedCanvas().toDataURL("image/png") , "IMAGEM DA ASSINATURA")
      
      handleProgress(sign.getTrimmedCanvas().toDataURL("image/png"))
     
      // onClose(sign.toDataURL("image/png"));
      
    }
  };


  const getSignFromCanvas = (ref: any) => {
    setSign(ref);
  };

//  const assinarTabletHandler = async () => {
//   setDisabled(true);

//   try {
//     const res = await services.apiCall.requestApi(
//       "wacom/assinar-tablet",
//       {},
//       "get"
//     );

//     console.log("RES:", res);
//     if(res){
//         const base64 = res.data || res;

//         if (base64 && base64.startsWith("data:image")) {
//           onClose(base64);
//           handleProgress(base64);
//         } else {
//           console.warn("base64 inválido:", base64);
//         }
//     }
    
//   } catch (err) {
//     console.error(err);
//   }

//   setDisabled(false);
// };
const assinarTabletHandler = async () => {
    setDisabled(true);

    try {
      const res = await fetch("http://localhost:5000/sign");

      if (!res.ok) {
        throw new Error("Erro ao chamar app de assinatura");
      }

      const base64 = await res.json()

      console.log("RES:", base64);

      if (base64 && base64.startsWith("data:image")) {
        onClose(base64);
        handleProgress(base64);
      } else {
        console.warn("base64 inválido:", base64);
      }

    } catch (err) {
      console.error(err);

      // alert("A aplicação de assinatura não está aberta");
    }

    setDisabled(false);
};
  return (
    <Dialog open={open}>
      <DialogTitle>Assinatura Manuscrito Digital</DialogTitle>

      <DialogContent style={{padding: 10}}>
        <SignatureCanvas
          penColor="black"
          onEnd={() => setIsSign(true)}
          canvasProps={{ width: 250, height: 38, style: {border: '1px solid #cecece', marginRight: 'auto', marginLeft: 'auto', display: 'block'}, className: "sigCanvas" }}
          ref={(ref: SignatureCanvas | null) => {
            getSignFromCanvas(ref);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button 
          variant="outlined" 
          onClick={assinarTabletHandler}>
          Assinar no Tablet
        </Button>
        <Button
          variant="outlined"
          onClick={capturarHandler}
          disabled={isSign ?  false : true}
        >
          Assinar
        </Button>
        <Button variant="outlined" onClick={clearHandler}>
          Limpar
        </Button>
        <Button variant="outlined" onClick={handleClose}>
          Fechar
        </Button>
      </DialogActions>
      
    </Dialog>
    
  );
}

const useStyles = makeStyles((theme) => ({
  signArea: {},
  btnFechar: {},
}));
